import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgProgressInProgress = (props) => /* @__PURE__ */ _jsxs("svg", {
	preserveAspectRatio: "none",
	overflow: "visible",
	style: { display: "block" },
	width: 48.6667,
	height: 48.6667,
	viewBox: "0 0 48.6667 48.6667",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "elements",
		children: [/* @__PURE__ */ _jsx("circle", {
			id: "Ellipse 2481",
			cx: 24.3333,
			cy: 24.3333,
			r: 23.3333,
			stroke: "#E6007E",
			strokeWidth: 2
		}), /* @__PURE__ */ _jsx("path", {
			id: "Ellipse 2483",
			d: "M24.3333 6.83333C27.7945 6.83333 31.178 7.85969 34.0558 9.78262C36.9337 11.7055 39.1767 14.4387 40.5012 17.6364C41.8258 20.8341 42.1723 24.3527 41.4971 27.7474C40.8218 31.1421 39.1551 34.2603 36.7077 36.7077C34.2603 39.1551 31.1421 40.8218 27.7474 41.4971C24.3527 42.1723 20.8341 41.8258 17.6364 40.5012C14.4387 39.1767 11.7055 36.9337 9.78261 34.0558C7.85969 31.178 6.83333 27.7945 6.83333 24.3333H24.3333V6.83333Z",
			fill: "url(#paint0_linear_0_39)"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsxs("linearGradient", {
		id: "paint0_linear_0_39",
		x1: 33.4682,
		y1: 14.3146,
		x2: -3.60015,
		y2: 50.7753,
		gradientUnits: "userSpaceOnUse",
		children: [/* @__PURE__ */ _jsx("stop", {
			offset: .21939,
			stopColor: "#E6007E"
		}), /* @__PURE__ */ _jsx("stop", {
			offset: 1,
			stopColor: "#FF75C1"
		})]
	}) })]
});
export default SvgProgressInProgress;
